module.exports = __webpack_public_path__ + "static/media/SCDream7.3bd0c8ca.otf";